export default function SahiFooter() {
  return (
    <footer className="border-t py-6 md:py-8 px-4 md:px-6 text-center text-xs md:text-sm text-gray-600">
      <div className="flex flex-col md:flex-row flex-wrap justify-center items-center gap-2 md:gap-2">
        <span><b>© 2026 Biziverse Pvt. Ltd.</b></span>
        <span className="hidden md:inline">Peach Campus, A/44 GIDC Electronics Estate, Gandhinagar, Gujarat 382016 INDIA</span>
        <span className="md:hidden">Peach Campus</span>
        <span className="md:hidden">A/44 GIDC Electronics Estate,</span>
        <span className="md:hidden">Gandhinagar, Gujarat 382016 INDIA</span>
        <div className="flex items-center gap-2">
          <a href="https://sahicrm.com/Web/policy.pdf" target="_blank" className="text-sahi-green hover:underline">Privacy Policy</a>
          <span>•</span>
          <a href="https://sahicrm.com/Web/STerms.pdf" target="_blank" className="text-sahi-green hover:underline">Sales Terms</a>
        </div>
      </div>
    </footer>
  );
}